module.exports = __webpack_public_path__ + "static/img/img07.51ad7e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img07.png
// module id = Y372
// module chunks = 1